/**
 * PRODUCT QUANTITY DROPDOWN - port of 1.4.7's QuantityPicker
 *
 * Total Restroom's product pages use a 1-10+ quantity dropdown. In 1.4.7, theme.js swapped that
 * dropdown for a number field when "10+" was picked, so larger quantities could be typed. Warehouse
 * 7.x has no such code - picking "10+" just added 10, so a PDP order was capped at 10.
 *
 * Used by both product cards:
 *   - snippets/product-variant-selector.liquid (templates/product*.json, "Dropdown" quantity type)
 *   - snippets/product-info-legacy.liquid (the PageFly product templates)
 * Each marks its dropdown with data-quantity-dropdown.
 *
 * On a variant change, 7.x re-renders the variant selector block and writes the previous quantity
 * back into the new markup, which is a fresh dropdown again. A typed quantity above 10 has no
 * matching option, so the dropdown ends up empty; it is swapped back to a field holding that value.
 *
 * Listeners are delegated from the document, so re-rendered and quick-view markup is covered.
 */
(() => {
  if (window.__productQuantitySelect) return;
  window.__productQuantitySelect = true;

  // Last quantity typed into a swapped field, keyed by the dropdown's id.
  const typedQuantities = {};

  const swapForInput = (select, value, focus) => {
    const selectWrapper = select.closest('.select-wrapper') || select;
    const input = document.createElement('input');

    input.id = select.id;
    input.className = 'product-form__quantity form__field form__field--small form__field--text';
    input.type = 'text';
    input.inputMode = 'numeric';
    input.pattern = '[0-9]*';
    input.name = 'quantity';
    input.value = value;
    input.setAttribute('data-quantity-field', '');

    if (select.hasAttribute('form')) {
      input.setAttribute('form', select.getAttribute('form'));
    }

    selectWrapper.replaceWith(input);

    if (focus) {
      input.focus();
      input.select();
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target;

    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-quantity-dropdown]')) return;

    if (select.value === '10') {
      // Only move focus when the shopper picked it, not when a re-render restored it.
      swapForInput(select, '10', event.isTrusted);
    } else if (select.value === '' && typedQuantities[select.id]) {
      swapForInput(select, typedQuantities[select.id], false);
    }
  });

  const isQuantityField = (element) => element instanceof HTMLInputElement && element.matches('[data-quantity-field]');

  // While typing, only digits are kept and the field may be empty. 1.4.7 forced it back to 1 on
  // every keystroke, so clearing "10" and typing 25 gave 125.
  document.addEventListener('input', (event) => {
    const input = event.target;

    if (!isQuantityField(input)) return;

    const digits = input.value.replace(/\D/g, '');

    if (digits !== input.value) {
      input.value = digits;
    }

    if (digits !== '') {
      typedQuantities[input.id] = digits;
    }
  });

  // On leaving the field (which also happens when the add to cart button is clicked) an empty or
  // zero quantity becomes 1.
  document.addEventListener('change', (event) => {
    const input = event.target;

    if (!isQuantityField(input)) return;

    input.value = Math.max(1, parseInt(input.value, 10) || 1);
    typedQuantities[input.id] = input.value;
  });
})();
